import React from "react";
import { Typography } from "./ui/typography";
import { Card, CardContent } from "./ui/card";
import Header from "../layouts/Header";
import recurringPaymentIcon from "../assets/images/autostack/bank-recurring-payment.svg";
import StackFormButtons from "./ui/stack-form-buttons";

interface SetUpRecurringPaymentProps {
  onContinue: () => void;
  onStepBack: () => void;
}

const SetUpRecurringPayment: React.FC<SetUpRecurringPaymentProps> = ({
  onContinue,
  onStepBack,
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex items-center justify-center min-h-[calc(100vh-64px)] px-4 py-8">
        <Card className="w-full max-w-2xl shadow-xl border-gray-100 rounded-3xl overflow-hidden">
          <CardContent className="px-6 py-12">
            <div className="flex flex-col items-center text-center space-y-4">
              <img src={recurringPaymentIcon} alt="Success" />

              <Typography variant="h2" className="mb-6 text-center max-w-72">
                Set-up recurring payment
              </Typography>

              <Typography variant="p" className="text-gray-600 max-w-72">
                You need to set up a recurring payment in your banking app with
                the ID reference on the next page.
              </Typography>

              <StackFormButtons
                onBack={onStepBack}
                onContinue={onContinue}
                continueText="Continue"
                isSubmitType={false}
                variant="rounded"
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SetUpRecurringPayment;
